<template>
  <div>
    <b-card title="Operative Notes Form">
      <b-row>
        <b-col md="6" cols="12">
          <b-form-group label="Patient Name" label-for="Name">
            <b-form-input
              id="Name"
              v-model="addForm.name"
              placeholder="Enter Patient Name"
            />
          </b-form-group>
        </b-col>
        <b-col md="6" cols="12">
          <b-form-group label="Age" label-for="Age">
            <b-form-input
              id="Name"
              type="number"
              v-model="addForm.age"
              placeholder="Enter Patient Age"
            />
            <p v-if="errorForm.age" class="ml-25 error">
              This field is required.
            </p>
          </b-form-group>
        </b-col>
        <b-col md="6" cols="12">
          <b-form-group label="Surgon Name" label-for="Name">
            <b-form-input
              id="Name"
              v-model="addForm.surgonName"
              placeholder="Enter Surgon Name"
            />
          </b-form-group>
        </b-col>
        <b-col md="6" cols="12">
          <b-form-group label="Nurse Name" label-for="Nurse Name">
            <b-form-input
              id="Nurse Name"
              v-model="addForm.nurseName"
              placeholder="Enter Nurse Name"
            />
          </b-form-group>
        </b-col>
        <b-col md="6" cols="12">
          <b-form-group label="Assistant Name" label-for="Assistant Name">
            <b-form-input
              id="Assistant Name"
              v-model="addForm.assistantName"
              placeholder="Enter Assistant Name"
            />
          </b-form-group>
        </b-col>
        <b-col md="6" cols="12">
          <b-form-group label="Unknown" label-for="Unknown">
            <b-form-input
              id="Name"
              v-model="addForm.unknown"
              placeholder="Enter Unknown"
            />
          </b-form-group>
        </b-col>
        <b-col md="6" cols="12">
          <b-form-group label="Unknown 2" label-for="Unknown">
            <b-form-input
              id="Name"
              v-model="addForm.unknown2"
              placeholder="Enter Unknown"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-col
        cols="12"
        md="12"
        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
      >
        <b-button
          style="margin: auto"
          variant="primary"
          @click="printOperativeNotes()"
        >
          Print Operative Notes Form
          <b-icon-person-check class="ml-1"></b-icon-person-check>
        </b-button>
      </b-col>
    </b-card>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      filename="patient card"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)"
      ref="html2PdfOpeartiveTable"
    >
      <section
        dir="ltr"
        class="pdf-content border border-dark font-modify m-5"
        slot="pdf-content"
      >
        <div
          class="border border-dark p-1"
          style="display: flex; justify-content: center"
        >
          <h3>Operative Notes</h3>
        </div>
        <div
          class="border border-dark p-1"
          style="display: flex; justify-content: space-between"
        >
          <span>
            <p class="px-1" style="background-color: white">
              Name: {{ addForm.name }}
            </p>
          </span>
          <span>
            <p class="px-4">Age: {{ addForm.age }}</p>
          </span>
        </div>

        <table style="width: 100%; table-layout: fixed">
          <tr style="height: 60px">
            <th class="px-1" style="text-align: left">
              Surgon : {{ addForm.surgonName }}
            </th>
            <th class="px-1" style="text-align: left">
              Atrejdkf : {{ addForm.unknown }}
            </th>

            <th class="px-1" style="text-align: left">
              Nurse : {{ addForm.nurseName }}
            </th>
          </tr>
          <tr class="px-1" style="height: 60px">
            <th class="px-1" style="text-align: left">
              Assiatant : {{ addForm.assistantName }}
            </th>
            <th class="px-1" style="text-align: left">
              Atrejdkf: {{ addForm.unknown2 }}
            </th>

            <th class="px-1" style="text-align: left"></th>
          </tr>
        </table>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BFormGroup,
  BFormSelect,
  BSpinner,
  BCardText,
  BInputGroup,
  BInputGroupAppend,
  BFormTextarea,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import VueHtml2pdf from 'vue-html2pdf';

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    vSelect,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BFormTextarea,
    VueHtml2pdf,
  },

  data() {
    return {
      addForm: {
        name: '',
        age: '',
        surgonName: '',
        nurseName: '',
        assistantName: '',
        unknown: '',
        unknown2: '',
      },
      errorForm: {
        name: '',
        age: '',
        surgonName: '',
        nurseName: '',
        assistantName: '',
        unknown: '',
      },
    };
  },
  methods: {
    printOperativeNotes() {
      this.$refs.html2PdfOpeartiveTable.generatePdf();
    },
  },
};
</script>

<style scoped>
.mb-md-0 {
  margin-top: 8px;
}

table {
  width: 94%;
  border: 1px solid;
  font-size: 11px;
}

.no-border {
  border: 0;
}

.square-dark {
  background-color: rgba(0, 0, 0, 0.2);
}

tr,
th,
td {
  border: 1px solid;
  width: 10px;
  height: 10px;
  text-align: center;
}

.font-modify {
  letter-spacing: normal !important;
}

.pdf-table {
  page-break-inside: avoid;
}

.square {
  width: 30px;
  /* Smaller width for squares */
  height: 30px;
  /* Smaller height for squares */
  background-color: #000;
  /* Color of the square */
  display: inline-block;
  /* Allows us to set width and height */
}

.centered-text {
  text-align: center;
  border: 2px solid #000;
  /* Border for the cell */
}

#table-above {
  border-collapse: collapse;
  /* Removes space between borders */
  font-size: 12px;
  /* Smaller font size for the entire table */
}

@media print {
  @page {
  }

  .pdf-table {
    page-break-before: avoid;
    page-break-inside: avoid;
  }
}

.pdf-table:first-child {
  margin-top: 1em;
  /* Adjust the value as needed */
  page-break-inside: avoid;
}
</style>
